export default function TableBody({ children }) {
  return <tbody className={'bidder-table-body'}>{children}</tbody>;
}
